export default __webpack_public_path__ + "static/media/br.26ae8e6a.svg";